import { produce } from 'immer';

import LoadingStatus from '@libs/loading-status';

import { AccountSignOutAction } from '@app/store/account/sign-out/actions';
import {
  ACCOUNT_SIGN_OUT_SUCCESS,
  SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_FAILURE,
  SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_REQUEST,
  SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { SoftLandingAction } from '@app/store/softLanding/actions';

export interface SoftLandingState {
  countOfDocuments: number;
  status: LoadingStatus;
}

const initialState = {
  countOfDocuments: 0,
  status: LoadingStatus.IDLE,
};

const reducer = (
  state: SoftLandingState = initialState,
  action: AccountSignOutAction | SoftLandingAction
) => {
  switch (action.type) {
    case ACCOUNT_SIGN_OUT_SUCCESS:
      return produce(state, (draft) => {
        draft.countOfDocuments = 0;
        draft.status = LoadingStatus.IDLE;
      });
    case SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_REQUEST:
      return produce(state, (draft) => {
        draft.status = LoadingStatus.PENDING;
      });
    case SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.countOfDocuments = action.payload;
        draft.status = LoadingStatus.SUCCEEDED;
      });
    case SOFT_LANDING__SIGNING_REQUEST_COUNT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.status = LoadingStatus.FAILED;
      });
    default:
      return state;
  }
};

export default reducer;
